module.exports = __webpack_public_path__ + "media/images/car_arrive-bcf45d8d5ebe8b229a8c806e3a0443ac.png";